'use client';
import { ACCOUNT_SETTINGS_PAGE_MODULES } from '#pplx/frontend/apps/ask/o11y/pageTTVModules.js';
import { OrgRolesPermissionsPage, OrgViewRolePage, OrgViewGroupPage, RedirectCreditsToUsage, RedirectProPerksToAccount, RedirectAccountConnectorsToComputer, RedirectAccountIntegrationsToComputer, RedirectTasksToNotifications, AccountIndexRedirect, } from '#pplx/frontend/apps/ask/page-components/account/accountRouteMapComponents.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
const AccountDetailsPage = Dynamic(async () => {
    const { AccountDetailsPage } = await import('#pplx/frontend/apps/ask/page-components/account/details.js');
    return { default: AccountDetailsPage };
}, { critical: true });
const ApiPortalRedirect = Dynamic(async () => {
    const { ApiPortalRedirect } = await import('#pplx/frontend/apps/ask/page-components/account/ApiPortalRedirect.js');
    return { default: ApiPortalRedirect };
}, { critical: true });
const OrgIndexPage = Dynamic(async () => {
    const { OrgIndexPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/index.js');
    return { default: OrgIndexPage };
}, { critical: true });
const OrgDetailsPage = Dynamic(async () => {
    const { OrgDetailsPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/details/index.js');
    return { default: OrgDetailsPage };
}, { critical: true });
const OrgMembersPage = Dynamic(async () => {
    const { OrgMembersPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/permissioned-members/members.js');
    return { default: OrgMembersPage };
}, { critical: true });
const OrgAnalyticsPage = Dynamic(async () => {
    const { OrgAnalyticsPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/analytics.js');
    return { default: OrgAnalyticsPage };
}, { critical: true });
const OrgIdentityPage = Dynamic(async () => {
    const { OrgIdentityPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/identity.js');
    return { default: OrgIdentityPage };
}, { critical: true });
const OrgDataPrivacyPage = Dynamic(async () => {
    const { OrgDataPrivacyPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/data-privacy.js');
    return { default: OrgDataPrivacyPage };
}, { critical: true });
const OrgEncryptionPage = Dynamic(async () => {
    const { OrgEncryptionPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/encryption.js');
    return { default: OrgEncryptionPage };
}, { critical: true });
const OrgPermissionsPage = Dynamic(async () => {
    const { OrgPermissionsPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/permissions.js');
    return { default: OrgPermissionsPage };
}, { critical: true });
const OrgSharedAppsPage = Dynamic(async () => {
    const { OrgSharedAppsPage } = await import('#pplx/frontend/apps/ask/restricted-feature-teammate-workstream/OrgSharedAppsPage.js');
    return { default: OrgSharedAppsPage };
}, { critical: true, restricted: true });
const OrgConnectorsPage = Dynamic(async () => {
    const { OrgConnectorsPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/connectors.js');
    return { default: OrgConnectorsPage };
}, { critical: true });
const OrgCredentialsVaultPage = Dynamic(async () => {
    const { OrgCredentialsVaultPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/credentials-vault.js');
    return { default: OrgCredentialsVaultPage };
}, { critical: true });
const AccountCredentialsVaultPage = Dynamic(async () => {
    const { AccountCredentialsVaultPage } = await import('#pplx/frontend/apps/ask/page-components/account/credentials-vault.js');
    return { default: AccountCredentialsVaultPage };
}, { critical: true });
const OrgSkillsPage = Dynamic(async () => {
    const { OrgSkillsPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/skills.js');
    return { default: OrgSkillsPage };
}, { critical: true });
const OrgPluginsPage = Dynamic(async () => {
    const { OrgPluginsPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/plugins.js');
    return { default: OrgPluginsPage };
}, { critical: true });
const OrgPluginSkillPage = Dynamic(async () => {
    const { OrgPluginSkillPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/plugins.js');
    return { default: OrgPluginSkillPage };
}, { critical: true });
const OrgPluginPage = Dynamic(async () => {
    const { OrgPluginPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/plugins.js');
    return { default: OrgPluginPage };
}, { critical: true });
const OrgCometSetupPage = Dynamic(async () => {
    const { OrgCometSetupPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/comet.js');
    return { default: OrgCometSetupPage };
}, { critical: true });
const OrgComputerSetupPage = Dynamic(async () => {
    const { OrgComputerSetupPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/computer.js');
    return { default: OrgComputerSetupPage };
}, { critical: true });
const OrgEnterpriseApisPage = Dynamic(async () => {
    const { OrgEnterpriseApisPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/enterprise-apis.js');
    return { default: OrgEnterpriseApisPage };
}, { critical: true });
const OrgCometTelemetryPage = Dynamic(async () => {
    const { OrgCometTelemetryPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/comet-telemetry.js');
    return { default: OrgCometTelemetryPage };
}, { critical: true });
const OrganizationBillingPage = Dynamic(async () => {
    const { OrganizationBillingPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/billing.js');
    return { default: OrganizationBillingPage };
}, { critical: true });
const OrgCreditsUsagePage = Dynamic(async () => {
    const { OrgCreditsUsagePage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/credits-usage.js');
    return { default: OrgCreditsUsagePage };
}, { critical: true });
const OrgCreditsUsageDetailPage = Dynamic(async () => {
    const { OrgCreditsUsageDetailPage } = await import('#pplx/frontend/apps/ask/page-components/account/org/admin-only/credits-usage-detail.js');
    return { default: OrgCreditsUsageDetailPage };
}, { critical: true });
const AccountShortcutsPage = Dynamic(async () => {
    const { AccountShortcutsPage } = await import('#pplx/frontend/apps/ask/page-components/account/shortcuts.js');
    return { default: AccountShortcutsPage };
}, { critical: true });
const AccountSiteInstructionsPage = Dynamic(async () => {
    const { AccountSiteInstructionsPage } = await import('#pplx/frontend/apps/ask/page-components/account/site-instructions.js');
    return { default: AccountSiteInstructionsPage };
}, { critical: true });
const AccountPreferencesPage = Dynamic(async () => {
    const { AccountPreferencesPage } = await import('#pplx/frontend/apps/ask/page-components/account/preferences.js');
    return { default: AccountPreferencesPage };
}, { critical: true });
const AccountPersonalizePage = Dynamic(async () => {
    const { AccountPersonalizePage } = await import('#pplx/frontend/apps/ask/page-components/account/personalize.js');
    return { default: AccountPersonalizePage };
}, { critical: true });
const AccountMemoryPage = Dynamic(async () => {
    const { AccountMemoryPage } = await import('#pplx/frontend/apps/ask/page-components/account/memory.js');
    return { default: AccountMemoryPage };
}, { critical: true });
const AccountPersonalizeMemoriesPage = Dynamic(async () => {
    const { AccountPersonalizeMemoriesPage } = await import('#pplx/frontend/apps/ask/page-components/account/personalize/memories.js');
    return { default: AccountPersonalizeMemoriesPage };
}, { critical: true });
const AccountNotificationsPage = Dynamic(async () => {
    const { AccountNotificationsPage } = await import('#pplx/frontend/apps/ask/page-components/account/notifications.js');
    return { default: AccountNotificationsPage };
}, { critical: true });
const AccountAnalyticsPage = Dynamic(async () => {
    const { AccountAnalyticsPage } = await import('#pplx/frontend/apps/ask/page-components/account/analytics.js');
    return { default: AccountAnalyticsPage };
});
const AccountComputerPage = Dynamic(async () => {
    const { AccountComputerPage } = await import('#pplx/frontend/apps/ask/page-components/account/computer.js');
    return { default: AccountComputerPage };
}, { critical: true });
const AccountDevicesPage = Dynamic(async () => {
    const { AccountDevicesPage } = await import('#pplx/frontend/apps/ask/page-components/account/devices.js');
    return { default: AccountDevicesPage };
}, { critical: true });
const AccountCreditsPage = Dynamic(async () => {
    const { AccountCreditsPage } = await import('#pplx/frontend/apps/ask/page-components/account/credits.js');
    return { default: AccountCreditsPage };
}, { critical: true });
const AccountHealthPage = Dynamic(async () => {
    const { AccountHealthPage } = await import('#pplx/frontend/apps/ask/health/components/Settings/AccountHealthPage.js');
    return { default: AccountHealthPage };
});
export const ACCOUNT_SETTINGS_TTV_MODULE = 'account-settings-route-rendered';
const accountRouteHandler = (Component) => ({
    Component,
    modules: ACCOUNT_SETTINGS_PAGE_MODULES,
});
const redirectRouteHandler = (Component) => ({
    Component,
    modules: EMPTY_ARRAY,
});
export const ORG_SETTINGS_ROUTE_HANDLERS = {
    '/account/org/details': accountRouteHandler(OrgDetailsPage),
    '/account/org/members': accountRouteHandler(OrgMembersPage),
    '/account/org/analytics': accountRouteHandler(OrgAnalyticsPage),
    '/account/org/identity': accountRouteHandler(OrgIdentityPage),
    '/account/org/data-privacy': accountRouteHandler(OrgDataPrivacyPage),
    '/account/org/encryption': accountRouteHandler(OrgEncryptionPage),
    '/account/org/permissions': accountRouteHandler(OrgPermissionsPage),
    '/account/org/roles-permissions': accountRouteHandler(OrgRolesPermissionsPage),
    '/account/org/roles-permissions/:roleId': accountRouteHandler(OrgViewRolePage),
    '/account/org/roles-permissions/groups/:groupId': accountRouteHandler(OrgViewGroupPage),
    '/account/org/apps': accountRouteHandler(OrgSharedAppsPage),
    '/account/org/connectors': accountRouteHandler(OrgConnectorsPage),
    '/account/org/credentials-vault': accountRouteHandler(OrgCredentialsVaultPage),
    '/account/org/skills': accountRouteHandler(OrgSkillsPage),
    '/account/org/plugins': accountRouteHandler(OrgPluginsPage),
    '/account/org/plugins/skills/:skillId': accountRouteHandler(OrgPluginSkillPage),
    '/account/org/plugins/:pluginId': accountRouteHandler(OrgPluginPage),
    '/account/org/comet': accountRouteHandler(OrgCometSetupPage),
    '/account/org/computer': accountRouteHandler(OrgComputerSetupPage),
    '/account/org/enterprise-apis': accountRouteHandler(OrgEnterpriseApisPage),
    '/account/org/comet-telemetry': accountRouteHandler(OrgCometTelemetryPage),
    '/account/org/credits-usage': accountRouteHandler(OrgCreditsUsagePage),
    '/account/org/billing': accountRouteHandler(OrganizationBillingPage),
    '/account/org/credits-usage/:creditLimitId': accountRouteHandler(OrgCreditsUsageDetailPage),
    '/account/org': accountRouteHandler(OrgIndexPage),
};
export const PERSONAL_ACCOUNT_ROUTE_HANDLERS = {
    '/account/details': accountRouteHandler(AccountDetailsPage),
    '/account/api/files/:repositoryUuid': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/playground/search': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/group': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/members': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/billing': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/keys': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/limits': redirectRouteHandler(ApiPortalRedirect),
    '/account/api/files': redirectRouteHandler(ApiPortalRedirect),
    '/account/api': redirectRouteHandler(ApiPortalRedirect),
    '/account/pro-perks': redirectRouteHandler(RedirectProPerksToAccount),
    '/account/pro-perks/:name': redirectRouteHandler(RedirectProPerksToAccount),
    '/account/tasks/:taskId': redirectRouteHandler(RedirectTasksToNotifications),
    '/account/tasks': redirectRouteHandler(RedirectTasksToNotifications),
    '/account/shortcuts': accountRouteHandler(AccountShortcutsPage),
    '/account/site-instructions': accountRouteHandler(AccountSiteInstructionsPage),
    '/account/preferences': accountRouteHandler(AccountPreferencesPage),
    '/account/personalize': accountRouteHandler(AccountPersonalizePage),
    '/account/memory': accountRouteHandler(AccountMemoryPage),
    '/account/health': accountRouteHandler(AccountHealthPage),
    '/account/personalize/memories': accountRouteHandler(AccountPersonalizeMemoriesPage),
    '/account/notifications': accountRouteHandler(AccountNotificationsPage),
    '/account/analytics': accountRouteHandler(AccountAnalyticsPage),
    '/account/computer': accountRouteHandler(AccountComputerPage),
    '/account/integrations': redirectRouteHandler(RedirectAccountIntegrationsToComputer),
    '/account/devices': accountRouteHandler(AccountDevicesPage),
    '/account/usage': accountRouteHandler(AccountCreditsPage),
    '/account/credits': redirectRouteHandler(RedirectCreditsToUsage),
    '/account/connectors': redirectRouteHandler(RedirectAccountConnectorsToComputer),
    '/account/credentials-vault': accountRouteHandler(AccountCredentialsVaultPage),
    '/account': accountRouteHandler(AccountIndexRedirect),
};
export const ACCOUNT_ROUTE_HANDLERS = {
    ...ORG_SETTINGS_ROUTE_HANDLERS,
    ...PERSONAL_ACCOUNT_ROUTE_HANDLERS,
};
//# sourceMappingURL=accountRouteMapShared.js.map